import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/custom.scss';
import './styles/variables.css';
import App from './App';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import 'bootstrap/dist/js/bootstrap';
import { AuthProvider } from './Auth/Auth';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <AuthProvider>
        <App />
    </AuthProvider>
);